import { Point } from '@ng-cloud/badger-core/models/interfaces/point';
import { FabricObject, Polyline } from 'fabric';
import { MapObject } from './map-object';

export class ContinuousRouteObject extends MapObject {
  defaultOptions: any = {
    strokeWidth: 5,
    stroke: '#0a8dff66',
    fill: null,
    selectable: false,
    evented: false,
    strokeLineCap: 'round',
    originX: 'center',
    originY: 'center',
    objectCaching: false
  };

  private polyline: Polyline;

  constructor(private points: Point[], config?: any) {
    super(config);
  }

  protected build(): FabricObject {
    const options = this.getOptions();

    this.polyline = new Polyline(this.points, options);

    return this.polyline;
  }
}
